module.exports = __webpack_public_path__ + "img/org04.11af144d.png";